import Toastify from 'toastify-js';

if (document.querySelector('.quotation')) {
  handleAttachments();

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-attachment-remove')) return;

    const id = e.target.closest('.quotation-product').getAttribute('data-id');
    const time = e.target.closest('.quotation-product').getAttribute('data-time');
    removeFileFromSessionStorage(id, time);

    window.location.reload();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-submit-quotation')) return;

    const hasErrors = handleRequiredInput();

    if (hasErrors === true) return;

    let formData = new FormData();
    formData.append('action', 'submit_quotation');
    formData.append('name', document.getElementById('quotation-name').value);
    formData.append('company', document.getElementById('quotation-company').value);
    formData.append('email', document.getElementById('quotation-email').value);
    formData.append('street', document.getElementById('quotation-street').value);
    formData.append('phone', document.getElementById('quotation-phone').value);
    formData.append('nr', document.getElementById('quotation-delivery-nr').value);
    formData.append('deadline', document.getElementById('quotation-delivery-deadline').value);
    formData.append('country', document.getElementById('quotation-delivery-country').value);

    

    if (sessionStorage.hasOwnProperty('gx_quotation_files')) {
      formData.append('files', sessionStorage.getItem('gx_quotation_files'));
    }

    if (document.getElementById('quotation-comment').value) {
      formData.append('comment', document.getElementById('quotation-comment').value);
    }

    fetch(adminUrl, {
      method: 'post',
      body: formData,
    })
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        document.getElementById('quotation-success').style.display = 'block';
        emptyInputs();
        sessionStorage.removeItem('gx_quotation_files');

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .catch((response) => {
        console.log(response);
      });
  });
}

function handleRequiredInput() {
  let errors = false;

  document
    .querySelectorAll('.form__request-quotation input[required]')
    .forEach((el) => {
      if (el.value.length < 1) {
        el.classList.add('has-error');

        Toastify({
          text: el.closest('.input-field').querySelector('label').innerText + ' is een verplicht veld',
          duration: 2000,
          className: 'error',
          avatar: themeUrl + '/assets/images/cancel.svg',
          gravity: 'bottom',
          position: 'right'
        }).showToast();

        errors = true;
      } else {
        el.classList.remove('has-error');
      }
    });

  return errors;
}

function emptyInputs() {
  document
    .querySelectorAll('.form__request-quotation input:not([type="submit"])')
    .forEach((el) => {
      el.value = '';
    });

  document.querySelector('.form__request-quotation textarea').value = '';
}

function handleAttachments() {
  if (sessionStorage.hasOwnProperty('gx_quotation_files')) {
    const files = JSON.parse(sessionStorage.getItem('gx_quotation_files'));

    files.forEach((file) => {

      console.log(file);
      
      if (!file.file_type.includes('image')) {
        let a = document.createElement('a');
        a.href = `data:${file.file_type};base64,${file.file_data}`;
        a.download = `${file.file_name}`;
        a.textContent = `${file.file_name}`;
        document.querySelector(`.quotation-product[data-id="${file.file_id}"][data-time="${file.time}"]`).querySelector('.info__attachment').prepend(a);

      } else {
        let img = document.createElement('img');
        img.src = `data:${file.file_type};base64,${file.file_data}`;
        document.querySelector(`.quotation-product[data-id="${file.file_id}"][data-time="${file.time}"]`).querySelector('.info__attachment').prepend(img);
      }

      document.querySelector(`.quotation-product[data-id="${file.file_id}"][data-time="${file.time}"]`).querySelector('.info__attachment').style.display = 'flex';
      
    });
  }
}

function removeFileFromSessionStorage(id, time) {
  if (sessionStorage.hasOwnProperty('gx_quotation_files')) {

    let files = JSON.parse(sessionStorage.getItem('gx_quotation_files'));

    const fileIndex = files.findIndex(obj => (obj.file_id == id && obj.time == time));
    if (fileIndex != -1) {
      files.splice(fileIndex, 1);
      files = JSON.stringify(files);
      sessionStorage.setItem('gx_quotation_files', files);
    }
  }
}

jQuery(function($){
    $('#quotation-delivery-deadline').datepicker({
        dateFormat: 'dd-mm-yy',
        minDate: 1 // voorkomt het kiezen van vandaag of verleden
    });
    
});